import axios from 'axios';

const API_BASE = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5001/api' 
  : '/api';

export const issuesApi = {
  // Public endpoints
  async getIssues(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    const response = await axios.get(`${API_BASE}/issues?${params}`);
    return response.data;
  },

  async getIssue(id) {
    const response = await axios.get(`${API_BASE}/issues/${id}`);
    return response.data;
  },

  async createIssue(issueData) {
    const response = await axios.post(`${API_BASE}/issues`, issueData);
    return response.data;
  },

  async upvoteIssue(id) {
    const response = await axios.post(`${API_BASE}/issues/${id}/upvote`);
    return response.data;
  },

  async getUpvoteStatus(id) {
    const response = await axios.get(`${API_BASE}/issues/${id}/upvote-status`);
    return response.data;
  },

  async getComments(issueId, sortBy = 'newest') {
    const response = await axios.get(`${API_BASE}/issues/${issueId}/comments?sortBy=${sortBy}`);
    return response.data;
  },

  async addComment(issueId, commentData) {
    const response = await axios.post(`${API_BASE}/issues/${issueId}/comments`, commentData);
    return response.data;
  },

  async markCommentHelpful(issueId, commentId) {
    const response = await axios.post(`${API_BASE}/issues/${issueId}/comments/${commentId}/helpful`);
    return response.data;
  },

  // Admin endpoints
  async adminLogin(email, password) {
    const response = await axios.post(`${API_BASE}/admin/login`, { email, password });
    return response.data;
  },

  async getAdminIssues(token) {
    const response = await axios.get(`${API_BASE}/admin/issues`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  },

  async updateIssue(id, updates, token) {
    const response = await axios.put(`${API_BASE}/admin/issues/${id}`, updates, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  },

  async updateStatus(id, status, resolutionNotes, token) {
    const response = await axios.put(`${API_BASE}/admin/issues/${id}/status`, 
      { status, resolutionNotes }, 
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  },

  async addAdminNotes(id, notes, token) {
    const response = await axios.post(`${API_BASE}/admin/issues/${id}/notes`, 
      { adminNotes: notes },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  },

  async addAdminComment(id, commentText, parentCommentId, token) {
    const response = await axios.post(`${API_BASE}/admin/issues/${id}/admin-comment`,
      { commentText, parentCommentId },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  },

  async deleteIssue(id, token) {
    const response = await axios.delete(`${API_BASE}/admin/issues/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  },

  async getStats(token) {
    const response = await axios.get(`${API_BASE}/admin/issues/stats`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  }
};

export default issuesApi;







